// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2sgHd","footer":"ModalFilter_footer__5aMN5"};